












import { Component, Prop, Vue } from "vue-property-decorator";

const LISTA = [
  "Você vai descobrir a data dos principais acontecimentos da sua vida e relacioná-la com o ciclo anual que estava vivendo.",
  "Será possível analisar cada sucesso e se preparar para repeti-lo novamente.",
  "Vai conseguir ter prosperidade na família, no trabalho e em questões financeiras detalhando seu Triângulo da Vida.",
  "Conseguirá multiplicar mais e mais os bons momentos da sua vida daqui pra frente pois saberá como eles se realizam. ",
  "Vai entender porque novos amores, novas conquistas financeiras e profissionais acontecem em ciclos de 1 a 9 anos. ",
  "Vai atingir picos de felicidade por meio do autoconhecimento e da prosperidade."
];

@Component
export default class extends Vue {
  // @Prop() private msg!: string;
  itens: Array<Item> = [];

  // Lifecycle hook
  mounted() {
    let counter = 0;
    this.itens = LISTA.map(function(item) {
      counter++;
      return new Item(counter, item);
    });
  }
}

class Item {
  numero: number;
  nome: string;
  constructor(numero: number, nome: string) {
    this.numero = numero;
    this.nome = nome;
  }
}
